import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TechnicalInfoIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.58 19.88H7.44L2.86 11.96L7.44 4.04H16.58L21.14 11.96L16.58 19.88ZM8.54 18.02H15.46L18.98 11.96L15.46 5.9H8.54L5.02 11.96L8.54 18.02ZM15.4 11.96C15.4 13.84 13.88 15.36 12 15.36C10.12 15.36 8.6 13.84 8.6 11.96C8.6 10.08 10.12 8.56 12 8.56C13.88 8.56 15.4 10.08 15.4 11.96ZM10.42 11.96C10.42 12.82 11.14 13.54 12 13.54C12.86 13.54 13.58 12.82 13.58 11.96C13.58 11.1 12.86 10.38 12 10.38C11.14 10.38 10.42 11.1 10.42 11.96Z" />
    </SvgIcon>
  );
});
